import { render, staticRenderFns } from "./DetailedListExamine.vue?vue&type=template&id=c99031f2&"
import script from "./DetailedListExamine.vue?vue&type=script&lang=js&"
export * from "./DetailedListExamine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports